import { render, staticRenderFns } from "./VasTransModal.vue?vue&type=template&id=093b2314&scoped=true"
import script from "./VasTransModal.vue?vue&type=script&lang=js"
export * from "./VasTransModal.vue?vue&type=script&lang=js"
import style0 from "./VasTransModal.vue?vue&type=style&index=0&id=093b2314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b2314",
  null
  
)

export default component.exports